// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    Input,TextField
} from "@mui/material";

// App Imports
import {changeProduct} from "./productSlice";
import {addProduct, editProduct} from "./ProductClient";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import {getAllProducts} from ".//ProductClient";
import Stack from "@mui/material/Stack";
import {NumericFormat} from "react-number-format";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import dayjs from "dayjs";


// Main Function
export default function ProductDrawer({contractDataPointDrawerState,contractDataPointDrawerMode}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************
    const dispatchData = useDispatch();

    const selectorProductId = useSelector((state) => state.productSlc.value.id);
    const selectorProductDrawerState = useSelector((state) => state.productSlc.value.productDrawerState);
    const selectorProductDrawerMode = useSelector((state) => state.productSlc.value.productDrawerMode);

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register, control, reset, handleSubmit} = useForm();


    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my Product data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorProductDrawerMode==="Add"){
            addProduct(data)
                .then(() => {
                    console.log("Product added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeProduct({
                    id: null, externalId: null, name: null, episodeName: null,
                    seasonExternalId: null, season: null, seasonName: null, seriesExternalId: null,
                    seriesName: null,derivativeOfProductId:null,derivativeOfSeriesId:null,photoStartDate:null,
                    lengthMinutes: null, m4mktGroup: null, initMkt: null, genre: null, productionType: null,
                    broadcastsPerWeek: null, budget: null, productionCost: null, producer: null, financialCode: null,
                    eidr: null, overedProduct: null, status: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    productGridRefresh: true, productDrawerState: false, productDrawerMode: null}))
            })}
        if(selectorProductDrawerMode==="Clone"){
            const { id, ...data } = data; // removes id
            addProduct(data)
                .then(() => {
                    console.log("Product cloned");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record cloned"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Cloning failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeProduct({id: null, externalId: null, name: null, episodeName: null,
                    seasonExternalId: null, season: null, seasonName: null, seriesExternalId: null,
                    seriesName: null,derivativeOfProductId:null,derivativeOfSeriesId:null,photoStartDate:null,
                    lengthMinutes: null, m4mktGroup: null, initMkt: null, genre: null, productionType: null,
                    broadcastsPerWeek: null, budget: null, productionCost: null, producer: null, financialCode: null,
                    eidr: null, coveredProduct: null, status: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    productGridRefresh: true, productDrawerState: false, productDrawerMode: null}))
            })}
        if(selectorProductDrawerMode==="Edit"){
            console.log("This is the Product Id I am going to edit")
            console.log(selectorProductId)
            editProduct(selectorProductId, data)
                .then(() => {
                    console.log("Product edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("trigger refresh")
                dispatchData(changeProduct({
                    productGridRefresh: true, productDrawerState: false, productDrawerMode: null}));
            })}
    };

    // ****************** END CRUD ****************************

    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function closeProductDrawer() {
        // setShowContractDataPointDrawer(false);
        dispatchData(changeProduct({productDrawerState: false }));
    };

    // ****************** END MISC ****************************


    // *********************** BEGIN DROPDOWNS **************************


    const fetchProductsForDropdown = () =>
        getAllProducts()

            .then(data => {
                console.log("Products List")
                console.log(data);
                setProducts(data);

            })
    useEffect(() => {
        console.log("This is for the products dropdown...");
        fetchProductsForDropdown();
    }, []);


// *********************** END DROPDOWNS **************************


    const product = useSelector((state) => state.productSlc.value);

    useEffect(() => {

        reset({
            ...product,
            photoStartDate: product.photoStartDate
                ? dayjs(product.photoStartDate)
                : null,


            budget: product.budget,
            productionCost: product.productionCost
        });


    }, [product, reset]);



    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);


    // ****************** BEGIN FORM ****************************

    function productForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{width: 1000, height: 300, pl: 5}}
                    role="presentation"
                >

                    <h2 style={{
                        paddingLeft: 0,
                        cursor: 'pointer'
                    }} onClick={() => closeProductDrawer()}>Product Form</h2>
                    <h4>{selectorProductDrawerMode} Mode</h4>
                    <Input
                        style={{ visibility: "hidden" }}
                        {...register('id', {required: true})}
                        id="id" name="id" label="id" aria-describedby="id_entry"
                        defaultValue={Number(useSelector((state) => state.productSlc.value.id))}
                    />
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('externalId', {required: false})}
                            id="externalId" name="externalId" label="External ID" aria-describedby="externalId_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.externalId)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('name', {required: true})}
                            id="name" name="name" label="Name" aria-describedby="name_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.name)}
                            sx={{width: 300}}/>
                        <TextField
                            {...register('episodeName', {required: false})}
                            id="episodeName" name="episodeName" label="Episode Name"
                            aria-describedby="episodeName_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.episodeName)}
                            sx={{width: 300}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('seriesExternalId', {required: false})}
                            id="seriesExternalId" name="seriesExternalId" label="Series External ID"
                            aria-describedby="seriesExternalId_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.seriesExternalId)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('seriesName', {required: false})}
                            id="seriesName" name="seriesName" label="Series Name" aria-describedby="seriesName_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.seriesName)}
                            sx={{width: 300}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('seasonExternalId', {required: false})}
                            id="seasonExternalId" name="seasonExternalId" label="Season External ID"
                            aria-describedby="seasonExternalId_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.seasonExternalId)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('seasonName', {required: false})}
                            id="seasonName" name="seasonName" label="Season Name" aria-describedby="seasonName_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.seasonName)}
                            sx={{width: 300}}/>
                        <TextField
                            {...register('season', {required: false})}
                            id="season" name="season" label="Season #" aria-describedby="season_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.season)}
                            sx={{width: 150}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        {/*<TextField*/}
                        {/*    {...register('photoStartDate', {required: true})}*/}
                        {/*    id="photoStartDate" name="photoStartDate" label="Photo Start Date"*/}
                        {/*    aria-describedby="photoStartDate_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.productSlc.value.photoStartDate)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <FormDatePicker
                            name="photoStartDate"
                            label="Photo Start Date"
                            control={control}
                            width={220}
                            variant = "outlined"
                        />
                        <TextField
                            {...register('lengthMinutes', {required: false})}
                            id="lengthMinutes" name="lengthMinutes" label="Length Minutes"
                            aria-describedby="lengthMinutes_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.lengthMinutes)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('m4mktGroup', {required: true})}
                            id="m4mktGroup" name="m4mktGroup" label="Made-For Market Group"
                            aria-describedby="m4mktGroup_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.m4mktGroup)}
                            sx={{width: 250}}/>
                        <TextField
                            {...register('initMkt', {required: true})}
                            id="initMkt" name="initMkt" label="Initial Market" aria-describedby="initMkt_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.initMkt)}
                            sx={{width: 250}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('genre', {required: false})}
                            id="genre" name="genre" label="Genre" aria-describedby="genre_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.genre)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('productionType', {required: false})}
                            id="productionType" name="productionType" label="Production Type"
                            aria-describedby="productionType_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.productionType)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('broadcastsPerWeek', {required: false})}
                            id="broadcastsPerWeek" name="broadcastsPerWeek" label="Broadcasts Per Week"
                            aria-describedby="broadcastsPerWeek_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.broadcastsPerWeek)}
                            sx={{width: 200}}/>

                        <TextField
                            {...register('coveredProduct', {required: false})}
                            id="coveredProduct" name="coveredProduct" label="Covered Product"
                            aria-describedby="coveredProduct_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.coveredProduct)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        {/*<TextField*/}
                        {/*    {...register('budget', {required: false})}*/}
                        {/*    id="budget" name="budget" label="Budget" aria-describedby="budget_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.productSlc.value.budget)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        {/*<TextField*/}
                        {/*    {...register('productionCost', {required: false})}*/}
                        {/*    id="productionCost" name="productionCost" label="Production Cost"*/}
                        {/*    aria-describedby="productionCost_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.productSlc.value.productionCost)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <Controller
                            name="budget"
                            control={control}
                            render={({ field }) => (
                                <NumericFormat
                                    value={field.value ?? ''}
                                    onBlur={field.onBlur}
                                    inputRef={field.ref}

                                    customInput={TextField}
                                    label="Budget"
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix="$"

                                    onValueChange={(values) => {
                                        field.onChange(values.floatValue);
                                    }}
                                />
                            )}
                        />
                        <Controller
                            name="productionCost"
                            control={control}
                            render={({ field }) => (
                                <NumericFormat
                                    value={field.value ?? ''}
                                    onBlur={field.onBlur}
                                    inputRef={field.ref}

                                    customInput={TextField}
                                    label="Production Cost"
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix="$"

                                    onValueChange={(values) => {
                                        field.onChange(values.floatValue);
                                    }}
                                />
                            )}
                        />
                        <TextField
                            {...register('producer', {required: false})}
                            id="producer" name="producer" label="Producer" aria-describedby="producer_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.producer)}
                            sx={{width: 200}}/>

                        <TextField
                            {...register('financialCode', {required: false})}
                            id="financialCode" name="financialCode" label="Financial Code"
                            aria-describedby="financialCode_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.financialCode)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('eidr', {required: false})}
                            id="eidr" name="eidr" label="EIDR" aria-describedby="eidr_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.eidr)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('derivativeOfProductId', {required: false})}
                            id="derivativeOfProductId" name="derivativeOfProductId" label="Derivative Of Product ID"
                            aria-describedby="derivativeOfProductId_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.derivativeOfProductId)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('derivativeOfSeriesId', {required: false})}
                            id="derivativeOfSeriesId" name="derivativeOfSeriesId" label="Derivative Of Series ID"
                            aria-describedby="derivativeOfSeriesId_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.derivativeOfSeriesId)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('status', {required: false})}
                            id="status" name="status" label="Status"
                            aria-describedby="status_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.status)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            disabled={true}
                            TextField{...register('createdBy', {required: false})}
                            id="createdBy" name="createdBy" label="Created By"
                            aria-describedby="createdBy_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.createdBy)}
                            sx={{width: 200}}/>

                        <TextField
                            disabled={true}
                            {...register('createdOn', {required: false})}
                            id="status" name="createdOn" label="Created On"
                            aria-describedby="createdOn_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.createdOn)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedBy', {required: false})}
                            id="lastModifiedBy" name="lastModifiedBy" label="Last Modified By"
                            aria-describedby="lastModifiedBy_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.lastModifiedBy)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedOn', {required: false})}
                            id="lastModifiedOn" name="lastModifiedOn" label="Last Modified On"
                            aria-describedby="lastModifiedOn_entry"
                            defaultValue={useSelector((state) => state.productSlc.value.lastModifiedOn)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>

                    <Button
                        type="submit"
                    >Submit</Button>
                    <Button onClick={() => closeProductDrawer()}>Cancel</Button>
                    <HiddenFields/>
                </Box>
            </form>
        );
    }

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>

            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorProductDrawerState}
                onClose={closeProductDrawer}
            >
                {productForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
